import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";

export default function AssessmentLayout() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#F9FAFB",
      }}
    >
      <Outlet />
    </Box>
  );
}